import styled from 'styled-components'

export const StyledDisplayContainer = styled.div`
  font-size: ${(props) => props.fontSize}px;
  width: 100%;
  height: auto;
  max-width: 100%;
  overflow: auto;
`
